import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import SplashLabel from '@/shared/content/blocks/helpers/SplashLabel.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSplashLabelSelected',
  setup(__props) {

const labels = useBlockLabels();
const { splashLabelSelected } = useGlobalLabels(GlobalLabels.product);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SplashLabel, {
    label: _unref(labels).overlaySelectedItem || _unref(splashLabelSelected),
    class: "bg-brandy not-italic"
  }, null, 8, ["label"]))
}
}

})